import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppComponent } from 'app/app.component';

@Component({
    selector: 'partner-settings-authorized-representative',
    templateUrl: './partner-settings-authorized-representative.component.html',
    styleUrls: ['./partner-settings-authorized-representative.component.scss',
        '../../../../../styles/style-layout.scss']
})

export class PartnerSettingsAuthorizedRepresentativeComponent {
    @Input()
    public menuPermissionActive!: string;

    constructor(private messageService: MessageService, public app: AppComponent) { }

    @Input()
    public merchantInfo: any;
}
